export default __webpack_public_path__ + "tmp_src/components/LocalizationForm/LocalizationForm.css.liquid";